/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeDashboardMilestoneStats
 */
export interface ChallengeDashboardMilestoneStats {
    /**
     * 
     * @type {string}
     * @memberof ChallengeDashboardMilestoneStats
     */
    milestoneId: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeDashboardMilestoneStats
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardMilestoneStats
     */
    targetAmount: number;
    /**
     * Number of users who completed this milestone
     * @type {number}
     * @memberof ChallengeDashboardMilestoneStats
     */
    completedCount: number;
    /**
     * Percentage of total participants who completed this milestone
     * @type {number}
     * @memberof ChallengeDashboardMilestoneStats
     */
    completionPercent: number;
    /**
     * Total number of rewards given across all users (for rewardPer milestones only)
     * @type {number}
     * @memberof ChallengeDashboardMilestoneStats
     */
    totalRewardsGiven?: number;
}

/**
 * Check if a given object implements the ChallengeDashboardMilestoneStats interface.
 */
export function instanceOfChallengeDashboardMilestoneStats(value: object): value is ChallengeDashboardMilestoneStats {
    if (!('milestoneId' in value) || value['milestoneId'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('targetAmount' in value) || value['targetAmount'] === undefined) return false;
    if (!('completedCount' in value) || value['completedCount'] === undefined) return false;
    if (!('completionPercent' in value) || value['completionPercent'] === undefined) return false;
    return true;
}

export function ChallengeDashboardMilestoneStatsFromJSON(json: any): ChallengeDashboardMilestoneStats {
    return ChallengeDashboardMilestoneStatsFromJSONTyped(json, false);
}

export function ChallengeDashboardMilestoneStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeDashboardMilestoneStats {
    if (json == null) {
        return json;
    }
    return {
        
        'milestoneId': json['milestoneId'],
        'description': json['description'],
        'targetAmount': json['targetAmount'],
        'completedCount': json['completedCount'],
        'completionPercent': json['completionPercent'],
        'totalRewardsGiven': json['totalRewardsGiven'] == null ? undefined : json['totalRewardsGiven'],
    };
}

export function ChallengeDashboardMilestoneStatsToJSON(json: any): ChallengeDashboardMilestoneStats {
    return ChallengeDashboardMilestoneStatsToJSONTyped(json, false);
}

export function ChallengeDashboardMilestoneStatsToJSONTyped(value?: ChallengeDashboardMilestoneStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'milestoneId': value['milestoneId'],
        'description': value['description'],
        'targetAmount': value['targetAmount'],
        'completedCount': value['completedCount'],
        'completionPercent': value['completionPercent'],
        'totalRewardsGiven': value['totalRewardsGiven'],
    };
}

